import mod from "-!./App.js?vue&type=script&lang=js&"; export default mod; export * from "-!./App.js?vue&type=script&lang=js&"